import React from 'react';
import VideoCallHistoryComponent from '../../../Components/Agent/VideoCallHistory';

export default function VideoCallHistory() {
    return (
        <div className='page-body'>
            <VideoCallHistoryComponent />
        </div>
    );
}